<template>
  <ul class="LandscapeNav flex h-header m-0 px-12 z-headers">
    <landscape-nav-link to="info">Home</landscape-nav-link>
    <landscape-nav-link
      v-if="isStartup"
      to="premises"
      match-children-routes
      has-menu
      >Premises</landscape-nav-link
    >
    <landscape-nav-link
      v-if="allowedToFeeds"
      to="feeds"
      match-children-routes
      has-menu
      >Feeds</landscape-nav-link
    >
    <landscape-nav-link to="topics" match-children-routes has-menu
      >Topics</landscape-nav-link
    >
    <landscape-nav-link
      v-if="!isStartup"
      to="insights"
      match-children-routes
      has-menu
      >Insights</landscape-nav-link
    >
    <landscape-nav-link
      v-if="allowedToOutputs"
      to="activity-analysis"
      match-children-routes
      >Analytics
    </landscape-nav-link>
  </ul>
</template>

<script>
import LandscapeNavLink from '@/components/common/header/LandscapeNavLink'
import {mapGetters} from 'vuex'

export default {
  name: 'LandscapeNav',
  components: {
    LandscapeNavLink
  },
  computed: {
    ...mapGetters(['allowedToOutputs', 'allowedToFeeds', 'isStartup'])
  }
}
</script>
